import { action, observable } from "mobx";
import captchaHandlerDecorate from "../../utils/captcha-deco-util";
import { CAPTCHA_PRE_AUTH } from "../../constants/urls";
import TinyInputStore from "../tiny-input/store";
import { useRef, useEffect } from "preact/hooks";
import { phoneNumber } from "../../utils/common-regex";
import Services from "../../services";
import ToastStore from "../toast/store";
import $$tracker from "../../tracker";

class SmsCodeInputStore {
  //手机号码输入框
  tinyInputPhoneNum = new TinyInputStore();

  //验证码输入框
  tinyInputPhoneCode = new TinyInputStore();

  //toast
  toast = new ToastStore();

  //toast内容
  @observable
  toastContent = {
    msg: ""
  };

  //发送验证码类型"login","register"
  @observable
  type;

  /**
   * 手机相关配置
   * @type {*[]}
   */
  @observable
  phoneMsgConfig = [
    {
      key: "phoneNum", type: "tel", placeholder: "手机号码", store: this.tinyInputPhoneNum, onBlur: () => {
        this.phoneNum();
      }
    }, {
      key: "phoneCode", type: "text", placeholder: "验证码", store: this.tinyInputPhoneCode, onBlur: () => {
        this.phoneCode();
      }
    }
  ];

  //获取验证码按钮/秒数
  @observable sendBtnText = "获取验证码";

  //起始秒数
  @observable count = 60;

  //按钮是否不可点击
  @observable btnDisable = true;

  //倒计时
  @observable timer;

  /**
   * 更新警告提示
   * @param type
   * @param msg
   */
  setWarnTip(type, msg) {
    this.phoneMsgConfig = this.phoneMsgConfig.map((item) => item.key === type ? {
      ...item,
      warnTip: msg
    } : item);
  }

  /**
   * 校验输入框的值
   */

  phoneNum() {
    if (!this.tinyInputPhoneNum.value) {
      return this.setWarnTip(this.phoneMsgConfig[0].key, "请输入手机号");
    } else if (!phoneNumber.test(this.tinyInputPhoneNum.value)) {
      return this.setWarnTip(this.phoneMsgConfig[0].key, "请输入正确的手机号");
    }

    this.setWarnTip(this.phoneMsgConfig[0].key, "");
    return this.tinyInputPhoneNum.value;
  }


  /**
   * 验证码
   */
  phoneCode() {
    if (!this.tinyInputPhoneCode.value) {
      return this.setWarnTip(this.phoneMsgConfig[1].key, "请输入验证码");
    }
    this.setWarnTip(this.phoneMsgConfig[1].key, "");
    return this.tinyInputPhoneCode.value;
  }

  /**
   * 点击"获取验证码"
   */
  @action.bound
  onSendCodeClick() {
    if (this.phoneNum()) {
      if(this.type==="login"){
        this.sendCodeByLogin();
      }else{
        this.sendCode();
      }

    } else {
      this.tinyInputPhoneNum.elementRef?.current?.focus();
    }
  }

  /**
   * 手机登录发送验证码
   * @param authParams
   * @returns {Promise<void>}
   */
  @action.bound
  @captchaHandlerDecorate()
  async sendCodeByLogin({ ...authParams }) {
    await Services.sendCodeByLogin({
      account: this.phoneNum(), ...authParams,
      client: "default"
    }).then(() => {
      // console.info('code:', res);

      //请求成功,倒计时开始
      this.timer = setInterval(() => {
        this.count = this.count - 1;
      }, 1000);

      this.tinyInputPhoneCode.elementRef?.current?.focus();

    }).catch(err => {
      // console.info(err);
      this.toastContent = { msg: err.message };
    });
  }

  /**
   * 注册获取验证码
   * @param authParams
   * @returns {Promise<void>}
   */
  @action.bound
  @captchaHandlerDecorate()
  async sendCode({ ...authParams }) {
    await Services.sendCode({
      mobile: this.phoneNum(), ...authParams,
      client: "default",
      channel: "register"
    }).then(() => {
      // console.info('code:', res);

      //请求成功,倒计时开始
      this.timer = setInterval(() => {
        this.count = this.count - 1;
      }, 1000);

      this.tinyInputPhoneCode.elementRef?.current?.focus();
      $$tracker.getCodeSuccess();

    }).catch(err => {
      // console.info(err);
      this.toastContent = { msg: err.message };
      $$tracker.getCodeFail();
    });
  }


  use() {

    this.tinyInputPhoneNum.elementRef = useRef();
    this.tinyInputPhoneCode.elementRef = useRef();

    useEffect(() => {
      return () => {
        clearInterval(this.timer);
        this.count = 60;
        this.btnDisable = false;
        this.sendBtnText = "获取验证码";
        this.toastContent = { msg: "" };
      };
    }, []);

    useEffect(
      () => {
        if (this.count > 0 && this.count < 60) {
          this.btnDisable = true;
          this.sendBtnText = `${this.count}s`;
        } else {
          clearInterval(this.timer);
          this.count = 60;
          this.btnDisable = false;
          this.sendBtnText = "获取验证码";
        }
      },

      [this.count]
    );

    useEffect(() => {
      if (this.toastContent.msg) {
        this.toast.visible = true;
        this.toast.msg = this.toastContent.msg;

      }
    }, [this.toastContent]);

  }
}

export default SmsCodeInputStore;
